import { render } from "./Premium.vue?vue&type=template&id=6830af64"
import script from "./Premium.vue?vue&type=script&lang=js"
export * from "./Premium.vue?vue&type=script&lang=js"

import "./Premium.vue?vue&type=style&index=0&id=6830af64&lang=scss"

import exportComponent from "/var/www/www-root/data/www/malmarket/malmarket-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__